"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CurrentLotteryCard_1 = __importDefault(require("../CurrentLotteryCard"));
var LotteryBanner = function (_a) {
    var withBonusConditionsIcon = _a.withBonusConditionsIcon, withTitle = _a.withTitle, smallPadding = _a.smallPadding, btnText = _a.btnText;
    return (react_1.default.createElement(CurrentLotteryCard_1.default, { isBanner: true, withBonusConditionsIcon: withBonusConditionsIcon, withTitle: withTitle, smallPadding: smallPadding, btnText: btnText }));
};
exports.default = LotteryBanner;
